import { union } from 'lodash';

import { CspDirectives } from './csp.model';
import * as googleCsp from './csp.google';

export const launchdarklyDomains = [
  'https://app.launchdarkly.com',
  'https://events.launchdarkly.com',
  'https://clientstream.launchdarkly.com',
  'https://clientsdk.launchdarkly.com',
].join(' ');

const fullstoryDomains = {
  js: 'https://edge.fullstory.com',
  connect: 'https://rs.fullstory.com',
};

export const devDomain = process.env.NODE_ENV === 'development' ? 'https://app.stihl-preview.com' : '';
export const devWsDomain = process.env.NODE_ENV === 'development' ? 'ws://localhost:8277' : '';
export const newRelicScript = 'https://js-agent.newrelic.com';
export const stihlDomain = 'https://*.stihl.com https://*.stihl.cloud';
export const trkknDomain = 'https://*.trkkn.com';
export const trboDomain = 'https://*.trbo.com';
export const tealiumiqDomain = 'https://*.tealiumiq.com';
const tealiumiqScript = '*.tiqcdn.com';
export const oneTrust = 'https://cdn.cookielaw.org https://*.onetrust.com';
const qualtricts = 'https://*.qualtrics.com';
const isPhraseContexEditorConfigured = process.env.NEXT_PUBLIC_PHRASE_PROJECT_ID ?? false;
export const phraseIncontextEditor = {
  js: isPhraseContexEditorConfigured ? 'https://phrase.com' : '',
  css: isPhraseContexEditorConfigured ? 'https://phrase.com' : '',
  image: isPhraseContexEditorConfigured ? 'https://phrase.com' : '',
  connect: isPhraseContexEditorConfigured ? 'https://api.phrase.com' : '',
};

export const newRelicDomain = 'https://bam.eu01.nr-data.net';

const _self = `'self'`;
const contentful = {
  url: ['https://graphql.contentful.com', 'https://cdn.contentful.com'].join(' '),
  assetsUrl: 'https://images.ctfassets.net',
};

const aem = {
  assetsUrl: 'https://*.stihl.de/',
};

const defaultCspDirectives: CspDirectives = {
  defaultSrc: `${_self} ${devDomain}`,
  connectSrc: `${_self} ${devDomain} ${devWsDomain} ${stihlDomain} ${trkknDomain} ${trboDomain} ${tealiumiqDomain} ${launchdarklyDomains} ${
    fullstoryDomains.connect
  } ${newRelicDomain} ${oneTrust} ${qualtricts} ${process.env.NEXT_PUBLIC_AUTH_URL} ${process.env.NEXT_PUBLIC_BASE_URL ?? ''} ${
    contentful.url
  } ${process.env.NEXT_PUBLIC_TRANSLATION_PATH} ${phraseIncontextEditor.connect} ${
    googleCsp.connect
  } https://pagead2.googlesyndication.com`,
  scriptSrc: `${_self} ${newRelicScript} ${stihlDomain} ${trkknDomain} ${trboDomain} ${tealiumiqDomain} ${tealiumiqScript} ${newRelicDomain} ${oneTrust} ${qualtricts} 'unsafe-eval' 'unsafe-inline' ${phraseIncontextEditor.js} ${fullstoryDomains.js} ${googleCsp.script}`,
  styleSrc: `${_self} 'unsafe-inline' ${phraseIncontextEditor.css} ${googleCsp.style} ${trboDomain}`,
  imgSrc: `${_self} ${stihlDomain} ${trboDomain} ${tealiumiqDomain} ${oneTrust} ${qualtricts} ${devDomain} ${phraseIncontextEditor.image} ${googleCsp.img} ${contentful.assetsUrl} ${aem.assetsUrl}`,
  frameSrc: `${_self} ${googleCsp.frame} ${qualtricts} ${trboDomain}`,
  fontSrc: `${_self} ${googleCsp.font} ${trboDomain}`,
};

export const getMetaCspHeader = (directives?: CspDirectives) => {
  const _directives = directives ? deepMerge(directives) : defaultCspDirectives;

  let header = '';
  for (const [key, value] of Object.entries(_directives)) {
    header += `${transformKeys(key)} ${value};`;
  }

  return header;
};

const transformKeys = (fieldName: string): string => {
  return fieldName
    .split('')
    .map((letter, index) => {
      return letter.toUpperCase() === letter ? `${index !== 0 ? '-' : ''}${letter.toLowerCase()}` : letter;
    })
    .join('');
};

const deepMerge = (customDirectives: CspDirectives): CspDirectives => {
  const mergedDirectives = Object.keys(customDirectives).reduce((directives, key) => {
    const uniqueValues = union((defaultCspDirectives[key] || _self).split(' '), customDirectives[key].split(' ')).join(' ');

    directives[key] = uniqueValues;
    return directives;
  }, {} as CspDirectives);

  return { ...defaultCspDirectives, ...mergedDirectives };
};
